/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Local advanced-reports DTOs.
 *
 * Rationale: this repo consumes published `@llamadapro/types` packages rather
 * than an editable local contracts workspace, so the new advanced reports
 * payloads live here and are exposed to the frontend through generated OpenAPI
 * clients.
 */
export enum AdvancedReportsCallDirection {
    BOTH = 'both',
    INCOMING = 'incoming',
    OUTGOING = 'outgoing',
}
